module.exports = __webpack_public_path__ + "media/images/icon_mypage01_17-17-675d7b34fade4ec6a27d0828b55c2e05.png";